import React from "react";

export type ContextProps = {
  loading: boolean;
  isAuthenticated: boolean;
  user: any;
  popupOpen: boolean;
  loginWithPopup: Function;
  handleRedirectCallback: Function;
  loginWithRedirect: Function;
  getTokenSilently: Function;
  getIdTokenClaims: Function;
  logout: Function;
  updateMetaData: Function;
};

const AuthContext = React.createContext<Partial<ContextProps>>({});

export default AuthContext;
